window.versionsRefreshFormatter = function(value, row) {
    let html = '';
    html += '<button class="button-versions-refresh btn btn-secondary btn-sm" data-id="'+row.id+'">';
    html += '<i class="fa fa-refresh me-2"></i>';
    html += __('Refresh');
    html += '</button>';
    return html;
};
